<div class="container p-5">
  <h1>You are not authorized to access this portal. Please contact the system administrator for more details.</h1>
</div>
